<app-input-container [label]="label" [obrigatorio]="obrigatorio">
  <div class="input-group input-group-sm ">
      <input 
        class="form-control" 
        [attr.disabled]="getAtivo()?null:'disableb'" 
        readonly 
        [name]="name" 
        [(ngModel)]="value"  
        [placeholder]="placeholder" 
        ngbDatepicker 
        #campo="ngbDatepicker" 
        (click)="campo.toggle()">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="campo.toggle()" type="button">
          <em class="fa fa-calendar"></em>
        </button>
      </div>
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="limparData(campo)" type="button">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>
</app-input-container>